"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var _ = require("lodash");
var Main_1 = require("./Main");
var Utils_1 = require("./Utils");
var isDevEnvironment = Utils_1.default.isDevEnvironment;
var EndpointConfig = (function () {
    function EndpointConfig(context) {
        this.context = context;
    }
    EndpointConfig.prototype.init = function (region) {
        var _this = this;
        var me = this;
        return new Promise(function (resolve, reject) {
            if (isDevEnvironment(_this.context)) {
                _this.region = 'us-east-1';
                resolve('us-east-1');
                return;
            }
            if (region) {
                me.region = region;
                resolve(me.region);
                return;
            }
            axios_1.default.get("/region.json")
                .then(function (response) {
                me.region = response.data.region;
                resolve(response.data.region);
            })
                .catch(function (error) {
                var loggerOnDefaultRegion = new Main_1.LoggingService(window, 'WebClientCommon', undefined, undefined, '<no SessionID>');
                loggerOnDefaultRegion.error("region discovery failed from referrer " + document.referrer + ", url:" + document.URL + "\n" + error);
                reject(false);
            });
        });
    };
    EndpointConfig.prototype.getStagePathPrefix = function () {
        switch (this.getStage()) {
            case "ALPHA":
                return "/gba";
            case "GAMMA":
                return "/gbinternal";
            case "PROD":
                return "/workdocs";
        }
        return "/workdocs";
    };
    EndpointConfig.prototype.getStage = function () {
        var pathname = this.context.location.pathname;
        if (_.startsWith(pathname, '/gba') || _.startsWith(pathname, "/pdfjs")) {
            return 'ALPHA';
        }
        if (_.startsWith(pathname, "/gbinternal")) {
            return 'GAMMA';
        }
        if (_.startsWith(pathname, "/workdocs")) {
            return 'PROD';
        }
        return "PROD";
    };
    EndpointConfig.prototype.getGorillaBoyEndpoint = function () {
        var region = this.region;
        var stage = this.getStage();
        return {
            ALPHA: "https://zocalo-alpha.us-east-1.amazonaws.com",
            GAMMA: "https://zocalo-gamma.us-east-1.amazonaws.com",
            PROD: "https://zocalo." + region + ".amazonaws.com"
        }[stage];
    };
    return EndpointConfig;
}());
;
exports.default = EndpointConfig;
